import { useMemo } from "react";

/**
 * Custom hook for managing user role detection and permissions
 * Centralizes role-based logic and provides consistent role checking
 */
export const useUserRole = () => {
  // Get user role and check if user is owner or admin
  const tokenPayload = JSON.parse(localStorage.getItem('tokenPayload') || '{}');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const doctorData = JSON.parse(localStorage.getItem('doctorData') || '{}');
  const doctorRole = localStorage.getItem('doctorRole') || '';

  // Memoize role calculations to avoid unnecessary recalculations
  const roleInfo = useMemo(() => {
    // Get user role from token payload
    const userRole = tokenPayload?.role?.toLowerCase();
    const userRic = tokenPayload?.ric?.toLowerCase();

    // Fix owner detection - check multiple sources for owner role
    const isOwner = tokenPayload.ric === 'owner' ||
                    doctorRole === 'owner' ||
                    doctorData.role_in_clinic === 'owner' ||
                    user.role_in_clinic === 'owner';

    const isAdmin = tokenPayload.role?.toLowerCase() === 'admin';
    const isDoctor =
      tokenPayload.role === "doctor" ||
      tokenPayload.role === "" ||
      tokenPayload.role === undefined ||
      user?.doctor; // Legacy doctor check
    const isFrontdesk =
      tokenPayload.role?.toLowerCase() === "front_desk" ||
      tokenPayload.role?.toLowerCase() === "frontdesk";
    const currentDoctorId =
      tokenPayload.userId ||
      tokenPayload.doctor_id ||
      tokenPayload.id ||
      user.id ||
      user.doctor_id ||
      doctorData.id;
    const clinicId = tokenPayload.clinic_id || doctorData.clinic_id || user.clinic_id;

    return {
      tokenPayload,
      user,
      doctorData,
      doctorRole,
      userRole,
      userRic,
      isOwner,
      isAdmin,
      isDoctor,
      isFrontdesk,
      currentDoctorId,
      clinicId
    };
  }, [tokenPayload, user, doctorData, doctorRole]);

  // Debug the dependencies
  console.log('🔥 DEPENDENCIES CHECK:', {
    isDoctor: roleInfo.isDoctor,
    isOwner: roleInfo.isOwner,
    isAdmin: roleInfo.isAdmin,
    currentDoctorId: roleInfo.currentDoctorId,
    clinicId: roleInfo.clinicId,
    isFrontdesk: roleInfo.isFrontdesk
  });

  return roleInfo;
};